function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    if (!timeout) context = args = null;
  };
  return function() {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}; 

(function() {
  // Scroll collapse main nav
  var scrollTop = document.documentElement.scrollTop;

  window.addEventListener("scroll", function() {
    var distanceY = window.pageYOffset || scrollTop,
      shrinkThreshold = 100,
      $header = $("#body_givesback > #givesback-header");

    if (distanceY > shrinkThreshold) $header.addClass("collapsed");
    else $header.removeClass("collapsed");
  });
 
  // Sticky subnav
  var $header = $("#body_givesback > #givesback-header"),
    $subnav = $(".subnav"),
    starting_top,
    subnav_blocks = $.makeArray($("[data-nav-id]")).reverse();

  if (!$subnav.length) {
    return;
  }

  starting_top = $subnav.offset().top - 86; // Shortened subnav height

  // $(window)
  //   .on(
  //     "scroll.stickySubnav",
  //     throttle(300, function() {
  //       $subnav.toggleClass(
  //         "stuck",
  //         (window.scrollY || window.pageYOffset) > starting_top
  //       );
  //     })
  //   )
  //   .scroll();

  // Subnav scroll behavior
  $(window).on(
    "scroll",
    function() {
      console.log('holatincho')
      subnav_blocks.some(function(e) {
        var scrolled_past =
          (window.scrollY || window.pageYOffset) +
            $header.innerHeight() +
            $subnav.innerHeight() >
          $(e).offset().top;
        if (scrolled_past) {
          $subnav.find(".active").removeClass("active");
          $subnav
            .find("ul a")
            .eq($(e).attr("data-nav-id"))
            .addClass("active");
        }
        return scrolled_past;
      });
    });

  // Subnav link click
  $subnav.on("click", "ul a", function(e) {
    e.preventDefault();
    var $e = $(this);

    onListDropdownClick($e, function() {
      $("html, body").animate(
        {
          scrollTop: $("[data-nav-id=" + $e.closest("li").index() + "]")[0]
            .offsetTop
        },
        400
      );
    });
  }); 

  $subnav.stick_in_parent({
      offset_top: 0
  });

  function onListDropdownClick($e, cb) {
    if ($e.hasClass("active")) {
      $e.closest("ul").toggleClass("opened");
      return;
    }

    $e.closest("ul").removeClass("opened");
    $e.closest("ul")
      .find(".active")
      .removeClass("active");
    $e.addClass("active");

    cb();
  }

  // Apply now clicked
  $("[data-apply-now]").on("click", function(e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("[data-nav-id='5']")[0].offsetTop
      },
      500
    );
  });

  // Calculate logic
  $("[data-calculate-button]").on("click", function(e) {
    e.preventDefault();
    calculate();
  });

  $("[data-calculate-form]").on("submit", function(e) {
    e.preventDefault(e);
    calculate();
  });

  function calculate() {
    var input = $("[data-fundraising-goal]")
        .val()
        .replace(/,/g, ""),
      goal =
        isNaN(input) || input < 0 || input == ""
          ? 0
          : parseInt(input.replace(/,/g, ""), 0),
      kingMultiplier = 187.5;
    $("[data-number-of-mattresses]").html(Math.ceil(goal / kingMultiplier));
  }


  /*  Application - School Fundraising Program  */

  $('.btnShowSchool').on('click', function (e) {
    $('#schoolModalLong').modal('show');
  }) 

  //tn_button secondary
  //button primary
  
  $('#schoolModalLong').on('hidden.bs.modal', function (e) {
    $("#school-contact").find('.is-invalid').removeClass("is-invalid");
    $("#school-contact").find('.is-valid').removeClass("is-valid");
    $("#school-contact")[0].reset();
    $("#school-contact").validate().resetForm();
    $('#school-contact').show();
    $('#schoolContent').show();
    $('#emailSchoolSuccess').hide();
    
  
  });


  var schoolFormValidation = function () {
    var myform = $('#school-contact');

    myform.on("submit", function (ev) {
      ev.preventDefault();

      if(!$('#school-contact').valid())
        return;

      $.ajax({
        type: myform.attr('method'),
        url: myform.attr('action'),
        async: true,
        data: myform.serialize(),
        success: function (data) {
          console.log('success');
          $('#school-contact').hide();
          $('#schoolContent').hide();
          $('#emailSchoolSuccess').show();
          myform[0].reset();
         },
        error: function error(xhr, ajaxOptions, thrownError) {
          console.log(thrownError);
        }
    }); 
    });
  }

  schoolFormValidation();

  $('#school-contact').validate({
    errorContainer:$('div.container'),
    rules: {
        'contact[AboutOurSchool]': "required",
        'contact[SchoolName]': "required",
        'contact[PTAContactName]': "required",
        'contact[PTAContactPhone]': "required",
        'contact[email]': {
          required: true,
          email: true
        },
        'contact[SchoolAddress]': "required",
        'contact[City]': "required",
        'contact[State]': "required",
        'contact[ZipCode]': "required"
    },
    errorElement: "em",
    errorPlacement: function (error, element) {
      // Add the `invalid-feedback` class to the error element
      error.addClass("invalid-feedback");

      if (element.prop("type") === "checkbox") {
        error.insertAfter(element.next("label"));
      } if (element.prop('type') === 'radio') {
        error.insertAfter(element.parent().children()[1]);
      }      else {
        error.insertAfter(element);
      }
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).addClass("is-valid").removeClass("is-invalid");
    }
  });

  $.extend($.validator.messages, { required: "This field is required. You have to enter something before submitting." });

})();
